import { useContext, useEffect, useState } from 'react';
import { requestList } from '../../api/agent';
import { AgentRequestResponse } from '../../structures/response/AgentRequestResponse';
import SocketContext from '../../context/SocketContext';

let timeoutId: NodeJS.Timeout;

export default function useAgentRequestList(): [
  AgentRequestResponse[],
  () => Promise<AgentRequestResponse[] | false>
] {
  const [response, setResponse] = useState<AgentRequestResponse[]>([]);
  const { socket } = useContext(SocketContext);

  const handleSocketMessage = (e: CustomEvent) => {
    if (e.detail.action === 'agent_request_prescoring_completed') {
      getData();
    }
  };

  useEffect(() => {
    if (socket?.readyState === 1) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      socket.addEventListener('frontendMessage', handleSocketMessage);
    }

    return () =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      socket?.removeEventListener('frontendMessage', handleSocketMessage);
  }, [socket?.readyState]);

  useEffect(() => {
    getData();

    return () => clearTimeout(timeoutId);
  }, []);

  async function getData() {
    try {
      const r = await requestList();
      setResponse(r);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(getData, 30000);
      return r;
    } catch (e) {
      console.log(e); // todo: remove this line
    }
    return false;
  }

  return [response, getData];
}
